var map = {
	"./aave.svg": 7801,
	"./ada.svg": 2390,
	"./bch.svg": 1220,
	"./bnb.svg": 5367,
	"./btc.svg": 5236,
	"./doge.svg": 9990,
	"./dot.svg": 8641,
	"./eth.svg": 1326,
	"./link.svg": 5669,
	"./ltc.svg": 2216,
	"./matic.svg": 5496,
	"./sol.svg": 9224,
	"./trx.svg": 538,
	"./usdc.svg": 6242,
	"./usdt.svg": 1354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1557;